/* Original Marsela editorial interactions. No requests, cart changes or storage. */
(() => {
  if (!customElements.get('ms-journal-reader')) {
    customElements.define('ms-journal-reader', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('[data-ms-reader]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.readerBody = this.querySelector('[data-ms-reader-body]');
        this.readerScroll = this.querySelector('[data-ms-reader-scroll]');
        this.querySelectorAll('[data-ms-story] > summary').forEach(summary => {
          summary.addEventListener('click', event => {
            event.preventDefault();
            this.lastTrigger = summary;
            const article = summary.parentElement.querySelector('[data-ms-story-content]').cloneNode(true);
            article.classList.add('ms-draft-article--modal');
            const heading = article.querySelector('.ms-reader-title');
            heading.id = this.dialog.getAttribute('aria-labelledby');
            this.readerBody.replaceChildren(article);
            this.previousOverflow = document.body.style.overflow;
            document.body.style.overflow = 'hidden';
            this.dialog.showModal();
            this.readerScroll.scrollTop = 0;
            this.querySelector('[data-ms-reader-close]').focus({ preventScroll: true });
          });
        });
        this.querySelector('[data-ms-reader-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.restoreFocus());
      }
      restoreFocus() {
        if (this.previousOverflow !== undefined) document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
        if (this.lastTrigger?.isConnected) this.lastTrigger.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          this.restoreFocus();
        }
      }
    });
  }
  function bindMaterials(root = document) {
    root.querySelectorAll('[data-ms-materials]').forEach(group => {
      if (group.dataset.msReady) return;
      group.dataset.msReady = 'true';
      group.querySelectorAll('details').forEach(detail => {
        detail.addEventListener('toggle', () => {
          if (detail.open) group.querySelectorAll('details').forEach(other => { if (other !== detail) other.open = false; });
        });
      });
    });
  }
  bindMaterials();
  document.addEventListener('shopify:section:load', event => bindMaterials(event.target));
})();

/* Theme-backed editorial pages: native links work without JS; query state keeps every guide shareable. */
(() => {
  function initJournal(root=document) {
    root.querySelectorAll('[data-ms-journal-index]').forEach(index=>{
      if(index.dataset.msEnhanced) return;
      const landing=index.querySelector('[data-ms-journal-landing]');
      const active=index.querySelector('[data-ms-journal-active]');
      const body=index.querySelector('[data-ms-journal-active-body]');
      const originalTitle=document.title;
      const entries=new Map([...index.querySelectorAll('[data-ms-journal-entry]')].map(el=>[el.dataset.msJournalEntry,el]));
      if(!landing||!active||!body||!entries.size) return;
      index.dataset.msEnhanced='true';
      const show=(slug,{focus=false}={})=>{
        const source=entries.get(slug)?.querySelector('[data-ms-journal-content]');
        landing.hidden=!!source;active.hidden=!source;
        body.replaceChildren();
        if(source){const copy=source.cloneNode(true);copy.querySelectorAll('[id]').forEach(el=>el.id=`view-${el.id}`);copy.querySelectorAll('a[href^="#"]').forEach(a=>a.setAttribute('href',`#view-${a.getAttribute('href').slice(1)}`));[copy,...copy.querySelectorAll('[aria-labelledby],[aria-describedby]')].forEach(el=>['aria-labelledby','aria-describedby'].forEach(attr=>{if(el.hasAttribute(attr))el.setAttribute(attr,el.getAttribute(attr).split(/\s+/).map(id=>`view-${id}`).join(' '));}));body.append(copy);const heading=body.querySelector('h1,h2');document.title=`${heading?.textContent||originalTitle} · Marsela Wall Co`;if(focus){active.scrollIntoView({block:'start'});if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true});}}}
        else{document.title=originalTitle;if(focus){index.scrollIntoView({block:'start'});const h=landing.querySelector('h1');h.tabIndex=-1;h.focus({preventScroll:true});}}
      };
      const fromURL=()=>show(new URL(location.href).searchParams.get('story'));
      index.querySelectorAll('[data-ms-journal-open]').forEach(a=>a.addEventListener('click',event=>{
        if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey) return;
        event.preventDefault();const slug=a.dataset.msJournalOpen;const url=new URL(a.href,location.href);url.searchParams.delete('ms_lang');history.pushState({marselaJournal:slug},'',url.pathname+url.search);show(slug,{focus:true});
      }));
      index.querySelectorAll('[data-ms-journal-back]').forEach(a=>a.addEventListener('click',event=>{
        if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();const url=new URL(location.href);url.searchParams.delete('story');url.hash='';history.pushState({marselaJournal:null},'',url.pathname+url.search);show(null,{focus:true});
      }));
      index.querySelectorAll('[data-ms-journal-filter]').forEach(button=>button.addEventListener('click',()=>{
        const topic=button.dataset.msJournalFilter;
        index.querySelectorAll('[data-ms-journal-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        index.querySelectorAll('[data-ms-journal-card]').forEach(card=>card.hidden=topic!=='all'&&card.dataset.topic!==topic);
      }));
      window.addEventListener('popstate',fromURL);fromURL();
    });
  }
  initJournal();document.addEventListener('shopify:section:load',event=>initJournal(event.target));
})();
